import { render, staticRenderFns } from "./TreeMenu.vue?vue&type=template&id=796ad66f&scoped=true"
import script from "./TreeMenu.vue?vue&type=script&lang=js"
export * from "./TreeMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ad66f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('796ad66f')) {
      api.createRecord('796ad66f', component.options)
    } else {
      api.reload('796ad66f', component.options)
    }
    module.hot.accept("./TreeMenu.vue?vue&type=template&id=796ad66f&scoped=true", function () {
      api.rerender('796ad66f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TreeMenu/TreeMenu.vue"
export default component.exports